import React from 'react';
import Modal from '../Base/Modal';
import { iosInstallUrl, androidInstallUrl } from '../../constants/Urls';

const CommentModal = ({ hideModal, device, post, post: { id, author: { id: authorId } } }) => (
  <Modal 
    contentLabel="댓글"
    onRequestClose={hideModal}
  >
    {{
      renderTitle: () => <span>댓글 작성은 카카오톡<br />모바일앱에서 가능합니다.</span>,
      renderContent: () => (
        <div className="app_btn">
          <button type="button" className="btn_g" onClick={() => window.open(post.getScheme(device.getIn(['os', 'name'])))}>
            <span className="inner_txt">카카오톡앱 열기</span>
          </button>
          <button type="button" className="btn_g btn_g2" onClick={() => window.open(device.getIn(['os', 'name']) ==='iOS' ? iosInstallUrl : androidInstallUrl)}>
            <span className="inner_txt">카카오톡앱 설치하기</span>
          </button>
        </div>
      )
    }}
  </Modal>
);

export default CommentModal;



// WEBPACK FOOTER //
// ./src/components/CommentModal/index.js